import { inRange } from 'range_check';

// inetnum 161.62.0.0 - 161.62.255.255, netname INSEL, Inselspital Bern, CH.
export const INSEL_NETWORK_CIDR = '161.62.0.0/16';

export function isInselNetwork(ip: string): boolean {
    return inRange(ip, INSEL_NETWORK_CIDR);
}
